import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as projectdossierQueryKey } from '../hooks/useProjectdossier'
import { linkProjectToProjectdossier } from '../services/linkProjectToProjectdossier'

export { useLinkProjectToProjectdossier }

const useLinkProjectToProjectdossier = () => {
  const { successAlert, errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: linkProjectToProjectdossier,
    onSuccess: (data) => {
      queryClient.setQueryData(
        [projectdossierQueryKey, data.projectdossierId],
        data,
      )
      successAlert('Project succesvol gekoppeld')
    },
    onError: (error: any) => {
      errorAlert('Fout bij het koppelen van het projectdossier', error)
    },
  })
}
